<div class="icon_header">
    <app-button-icon [imgUrl]="'assets/svg/plus-icon.svg'" [mat-dialog-close]="false"> </app-button-icon>
</div>
<div class="content">
    <h4>{{data.product_name}}</h4>
    <h3>Product Files</h3>
    <div class="bt_wrap">
        <app-download-button *ngFor="let file of data.filelist" [name]="file.file?.label || file.file?.filename || file.filename" [downloadable]="false" [fileSize]="file.file?.filesize" [fileType]="file.extension" [matDialogClose]="file"></app-download-button>
    </div>
</div>